{
    "Accessibility menu": "Меню за достъпност",
    "Close": "Затвори",
    "Text and Reading": "Текст и четене",
    "Navigation and Interaction": "Навигация и взаимодействие",
    "Text Align": "Подравняване на текста",
    "Align Left": "Подравни вляво",
    "Align Center": "Подравни в центъра",
    "Align Right": "Подравни вдясно",
    "Adjust Font Size": "Настройка на размера на шрифта",
    "Highlight Title": "Открояване на заглавието",
    "Highlight Links": "Открояване на връзките",
    "Readable Font": "Четим шрифт",
    "Color and Contrast": "Цвят и контраст",
    "Dark Contrast": "Тъмен контраст",
    "Light Contrast": "Светъл контраст",
    "High Contrast": "Висок контраст",
    "High Saturation": "Висока наситеност",
    "Low Saturation": "Ниска наситеност",
    "Monochrome": "Монохромен",
    "Tools": "Инструменти",
    "Reading Guide": "Ръководство за четене",
    "Big Cursor": "Голям курсор",
    "Increase Font Size": "Увеличи размера на шрифта",
    "Decrease Font Size": "Намали размера на шрифта",
    "Letter Spacing": "Разстояние между буквите",
    "Line Height": "Височина на реда",
    "Font Weight": "Дебелина на шрифта",
    "Dyslexia Font": "Шрифт за дислексия",
    "Language": "Език",
    "Accessibility widget": "Отвори меню за достъпност",
    "Accessibility Profiles": "Профили за достъпност",
    "Cognitive Disability": "Когнитивна увреденост",
    "Seizure Safe": "Безопасно за епилепсия",
    "Accessibility statement": "Декларация за достъпност",
    "ADHD": "ADHD",
    "Low Vision": "Слабо зрение",
    "Pause Animations": "Спри анимациите",
    "Animation paused": "Анимацията е спряна",
    "Reset all settings": "Нулиране на настройките",
    "Shortcut:": "Пряк път:",
    "Epilepsy Safe Mode": "Безопасен режим при епилепсия",
    "Mute sounds": "Заглушаване на звуците",
    "Page read": "Четене на страницата",
    "Page read controls": "Контроли за четене на страницата",
    "Pause": "Пауза",
    "Resume": "Продължи",
    "Stop": "Спри",
    "Settings": "Настройки",
    "Speed": "Скорост",
    "Voice": "Глас",
    "Close accessibility menu": "Затваряне на менюто за достъпност",
    "Back to accessibility menu": "Назад към менюто за достъпност",
    "Search languages": "Търсене на езици",
    "Selected language": "Избран език",
    "View accessibility statement (opens in new window)": "Преглед на декларацията за достъпност (отваря се в нов прозорец)",
    "Visit CookieYes website (opens in new window)": "Посетете уебсайта на CookieYes (отваря се в нов прозорец)",
    "Reset all accessibility settings to default": "Възстановяване на всички настройки за достъпност по подразбиране"
}
